import React from "react";
import "./App.css";
import GameContainer from "./components/gameContainer";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div className="App">
      <GameContainer />
    </div>
  );
}

export default App;
